// =============================================================================
//          (c) Copyright 2021 by Brinks Home Security | Dallas, TX, USA
// =============================================================================
// Version   : 0.1.1
// Created at: 08.24.16
// Project   : Brinks Home Security Shared Assets
// -----------------------------------------------------------------------------
// Jumplinks are internal links on a page, used to navigate within the page.
// -> Add the .js-jumplink class to an <a> and set its href to the id of the
//    element the jumplink should scroll to.
// -----------------------------------------------------------------------------

import FixedHelper from './fixed-helper'

const Jumplink = (($) => {
  // Target all <a> tags with an internal href
  const SELECTOR = '.js-jumplink'

  /* --------------------------------------------------------------------------
    Public Functions
  -------------------------------------------------------------------------- */

  let Jumplink = {
    // Enable smooth scrolling behavior for all jumplinks on the page
    init () {
      FixedHelper.initTopHeightTracker()

      $(SELECTOR).on('click', function () {
        const target = this.hash
        const $target = $(target)
        const animDuration = 900

        $('html, body').stop()
          .animate({
            scrollTop: $target.offset().top - FixedHelper.topHeight
          }, animDuration, 'swing')
      })
    }
  }

  return Jumplink
})(jQuery)

export default Jumplink
